import PropTypes from "prop-types";
import classnames from "classnames";
import pillsPropType from "../../ChildLinks/propTypes/pills";
import styles from "./index.css";
import ChildLinks from "../../ChildLinks";
import Pill from "../../ChildLinks/Pill";
import { LARGE_VIEWPORT } from "../../../state/modules/layout/constants";

const Pills = ({ pills, viewport, show }) => {
  if (!pills.length) return null;

  const className = classnames(styles.container, {
    [styles.hidden]: !show
  });

  if (viewport === LARGE_VIEWPORT) {
    return (
      <div className={className}>
        <ChildLinks />
      </div>
    );
  } else {
    return (
      <ul className={className} data-auto-id="childLinksContainer">
        {pills.map(p => (
          <Pill {...p} key={p.friendlyName} extraClassName={styles.pill} />
        ))}
      </ul>
    );
  }
};

Pills.propTypes = {
  pills: pillsPropType.isRequired,
  viewport: PropTypes.string.isRequired,
  show: PropTypes.bool
};

Pills.defaultProps = {
  show: true
};

export default Pills;
